import React, { useEffect, useState } from 'react';

import useNavParams from 'hooks/useNavParams';
import { useTranslation } from 'react-i18next';

import FormControl from '@mui/material/FormControl';

import { useEditPageContext } from '../EditPage';
import { Autocomplete } from 'components/shared/index';
import { get } from 'lodash';

interface ViewWithId {
  [key: string]: any;
}

export interface InnerViewNavigatorProps {
  setCurrentView: (view: any) => void;
  views?: readonly ViewWithId[];
  currentView?: ViewWithId;
  navigatorValueGetter?: string;
  navigatorLabelGetter?: string[];
}

interface Option {
  id: any;
  label: string;
}

const createLabelFromStringArray = (navigatorLabelGetter, obj) => {
  const labelArray: string[] = [];

  if (navigatorLabelGetter) {
    navigatorLabelGetter.forEach((getter) => {
      const value = get(obj, getter);
      labelArray.push(value);
    });
  }

  return labelArray.join(' - ');
};

const InnerViewNavigator: React.FC<InnerViewNavigatorProps> = ({
  setCurrentView,
  views,
  currentView,
  navigatorValueGetter = 'code',
  navigatorLabelGetter = ['code']
}) => {
  const { t } = useTranslation('common');
  const { params } = useNavParams();
  const { isEditable } = useEditPageContext();
  const [options, setOptions] = useState<Option[]>([]);
  const defaultItem = {
    id: currentView ? currentView[navigatorValueGetter] : '',
    label: createLabelFromStringArray(navigatorLabelGetter, currentView)
  };

  useEffect(() => {
    if (views) {
      const options = views.map((item) => {
        return {
          id: item[navigatorValueGetter],
          label: createLabelFromStringArray(navigatorLabelGetter, item)
        };
      });
      setOptions(options);
    }
  }, [views]);

  const onSelected = (selected: Option | null) => {
    const selectedView = views?.find(
      (item) => item[navigatorValueGetter] === selected?.id
    );
    setCurrentView(selectedView);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <FormControl variant="standard" sx={{ minWidth: 120 }}>
        <Autocomplete
          variant="outlined"
          disabled={isEditable}
          disableClearable={true}
          value={defaultItem}
          options={options}
          idProperty="id"
          label={t(`tableTabs.${params?.page.toUpperCase()}`)}
          onSelected={onSelected}
        />
      </FormControl>
    </div>
  );
};

export default InnerViewNavigator;
